// extracted by mini-css-extract-plugin
export default {"technicalText":"TechnicalText__technicalText-RCwMs"};